import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import ButtonTable from '../common/table/buttonTable';

import { setModoTela, initForm } from './freteActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

class FreteForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		let veiculo = this.props.listaVeiculo.filter(item => item.id == this.props.formularioValues.id_veiculo)[0];

		let kmTotal = 0;
		let custoTotal = 0;
		(this.props.formularioValues.itens || []).filter(item => item.ativo).forEach((item, i) => {
			kmTotal += parseFloat(FormatUtils.formatarValorBanco(item.km_total, 0));
			custoTotal += parseFloat((parseFloat(FormatUtils.formatarValorBanco(item.custo_km_rodado, 2)) * parseFloat(FormatUtils.formatarValorBanco(item.km_total, 0))).toFixed(2));
		});
		const custoMedioKmRodado = parseFloat((kmTotal > 0 ? custoTotal / kmTotal : 0).toFixed(2));

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='datahora_agendamento'
								component={LabelAndInputDateTime}
								label='Agendamento' placeholder='Informe'
								cols='12 1 1 1'
								readOnly={readOnly}
								minWidth={180} />
						</Row>
						<Row>
							<Field
								name='id_motorista'
								component={Select}
								options={this.props.listaMotorista}
								label='Motorista'
								cols='12 12 12 6'
								placeholder='Selecione o motorista'
								readOnly={readOnly} />

							<Field
								name='id_veiculo'
								component={Select}
								options={this.props.listaVeiculo.filter(veiculo => !veiculo.reboque)}
								label='Veículo'
								cols='12 12 4 2'
								placeholder='Selecione o veículo'
								readOnly={readOnly} />

							<Field
								name='id_carreta1'
								component={Select}
								options={this.props.listaVeiculo.filter(veiculo => veiculo.reboque)}
								label='Carreta 1'
								cols='12 12 4 2'
								placeholder='Selecione a carreta'
								readOnly={readOnly} />

							<Field
								name='id_carreta2'
								component={Select}
								options={this.props.listaVeiculo.filter(veiculo => veiculo.reboque)}
								label='Carreta 2'
								cols='12 12 4 2'
								placeholder='Selecione a carreta'
								readOnly={readOnly} />
						
							<Field
								name='descricao'
								component={LabelAndInput}
								label='Descrição' placeholder='Informe a descrição'
								cols='12 12 12 12'
								readOnly={readOnly} />                
						
						</Row>
						<Row>
							<LabelAndInputNumber
								label='Km Total' 
								placeholder='Informe a km total'
								cols='12 1 1 1'
								minWidth={200}
								casas={0}
								readOnly={'readOnly'}
								value={FormatUtils.formatarValorTela(kmTotal, 0)}
								onChange={data => {
								}} />

							<LabelAndInputNumber
								label='Custo Total' 
								placeholder='Informe a custo total'
								cols='12 1 1 1'
								minWidth={200}
								casas={2}
								readOnly={'readOnly'}
								value={FormatUtils.formatarValorTela(custoTotal, 2)}
								onChange={data => {
								}} />

							<LabelAndInputNumber
								label='Custo Km Rodado' 
								placeholder='Informe a custo km rodado'
								cols='12 1 1 1'
								minWidth={200}
								casas={2}
								readOnly={'readOnly'}
								value={FormatUtils.formatarValorTela(custoMedioKmRodado, 2)}
								onChange={data => {
								}} />
						</Row>

						<br />

						{(this.props.formularioValues.itens || []).filter(item => item.ativo).map((item, i) => {
							
							return (
								<Row key={item.id || item.idAux}>
									<Grid cols='12 12 12'>
										<ContentCard>
											<ContentCardHeader
												style={{
													background: 'linear-gradient(135deg, #0057B8, #2A67B1)',
													color: '#FFF',
													borderRadius: '8px 8px 0 0',
													padding: '12px 16px',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'space-between'
												}}
											>
												<h3
													className='card-title'
													style={{
														margin: 0,
														color: '#FFF',
														fontWeight: 600,
														display: 'flex',
														alignItems: 'center',
														width: '50%',
														paddingLeft: 16
													}}
												>
													<i
														className='fas fa-route'
														style={{
															marginRight: 10,
															color: '#FFF'
														}}
													/>
													Rota {i + 1}
												</h3>

												<div className='card-tools'
													style={{
														width: '50%',
														textAlign: 'right',
														paddingRight: 16
													}}>
													<button
														type='button'
														className='btn btn-flat btn-outline-light'
														style={{
															borderRadius: 20,
															width: 38,
															height: 38
														}}
														onClick={() => {
															if (item.id) {
																this.props.initForm({
																	...this.props.formularioValues,
																	itens: this.props.formularioValues.itens.map(itemAux => {
																		if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																			return {
																				...itemAux,
																				ativo: false
																			}
																		} else {
																			return itemAux;
																		}
																	})
																}, true);
															} else {
																this.props.initForm({
																	...this.props.formularioValues,
																	itens: this.props.formularioValues.itens.filter(itemAux => item.idAux != itemAux.idAux)
																}, true);
															}
														}}
													>
														<i className='fas fa-trash-alt'></i>
													</button>
												</div>
											</ContentCardHeader>
											<ContentCardBody style={{ backgroundColor: '#f4f7fb' }}>
												<Row>
													<Select
														options={[
															{ id: 'unidade', valor: 'Base' }, 
															{ id: 'cliente', valor: 'Cliente' },
															{ id: 'distribuidora', valor: 'Distribuidora' },
															{ id: 'local', valor: 'Outro Local' }
														]}
														cols='12 1 1 1'
														minWidth={200}
														label='Origem'
														placeholder='Selecione a origem'
														readOnly={readOnly}
														value={item.origem}
														onChange={(data) => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			origem: data,
																			id_unidade_origem: null,
																			id_cliente_origem: null,
																			id_endereco_origem: null,
																			id_distribuidora_origem: null,
																			id_local_origem: null,
																			latitude_origem: null,
																			longitude_origem: null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />
																								
													{item.origem == 'unidade' &&
													<Select
														options={this.props.listaUnidade}
														cols='12 3 3 3'
														label='Unidade'
														placeholder='Selecione a unidade'
														readOnly={readOnly}
														value={item.id_unidade_origem}
														onChange={(data) => {

															const unidade = this.props.listaUnidade.filter(item => item.id == data)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_unidade_origem: data,
																			latitude_origem: unidade ? unidade.latitude : null,
																			longitude_origem: unidade ? unidade.longitude : null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}
													
													{item.origem == 'cliente' &&
													<Select
														options={this.props.listaCliente}
														cols='12 3 3 3'
														label='Cliente'
														placeholder='Selecione o cliente'
														readOnly={readOnly}
														value={item.id_cliente_origem}
														onChange={(data) => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_cliente_origem: data,
																			id_endereco_origem: null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}

													{item.origem == 'cliente' &&
													<Select
														options={this.props.listaEndereco.filter(endereco => endereco.id_cliente == item.id_cliente_origem)}
														cols='12 3 3 3'
														label='Endereço'
														placeholder='Selecione o endereço'
														readOnly={readOnly}
														value={item.id_endereco_origem}
														onChange={(data) => {
															
															const endereco = this.props.listaEndereco.filter(item => item.id == data)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_endereco_origem: data,
																			latitude_origem: endereco ? endereco.latitude : null,
																			longitude_origem: endereco ? endereco.longitude : null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}

													{item.origem == 'distribuidora' &&
													<Select
														options={this.props.listaDistribuidora}
														cols='12 3 3 3'
														label='Distribuidora'
														placeholder='Selecione a distribuidora'
														readOnly={readOnly}
														value={item.id_distribuidora_origem}
														onChange={(data) => {

															const distribuidora = this.props.listaDistribuidora.filter(item => item.id == data)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_distribuidora_origem: data,
																			latitude_origem: distribuidora ? distribuidora.latitude : null,
																			longitude_origem: distribuidora ? distribuidora.longitude : null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}

													{item.origem == 'local' &&
													<Select
														options={this.props.listaLocal}
														cols='12 3 3 3'
														label='Outro Local'
														placeholder='Selecione o local'
														readOnly={readOnly}
														value={item.id_local_origem}
														onChange={(data) => {

															const local = this.props.listaLocal.filter(item => item.id == data)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_local_origem: data,
																			latitude_origem: local ? local.latitude : null,
																			longitude_origem: local ? local.longitude : null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}

													<LabelAndInput
														cols='12 1 1 1'
														minWidth={300}
														label='Localizacão'
														readOnly={'readOnly'}
														placeholder=''
														value={item.latitude_origem && item.longitude_origem ? `${item.latitude_origem}, ${item.longitude_origem}` : ''}
														onChange={(data) => {
														}} />
												</Row>
												<Row>
													<Select
														options={[
															{ id: 'unidade', valor: 'Base' }, 
															{ id: 'cliente', valor: 'Cliente' },
															{ id: 'distribuidora', valor: 'Distribuidora' },
															{ id: 'local', valor: 'Outro Local' }
														]}
														cols='12 1 1 1'
														minWidth={200}
														label='Destino'
														placeholder='Selecione o destino'
														readOnly={readOnly}
														value={item.destino}
														onChange={(data) => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			destino: data,
																			id_unidade_destino: null,
																			id_cliente_destino: null,
																			id_endereco_destino: null,
																			id_distribuidora_destino: null,
																			id_local_destino: null,
																			latitude_destino: null,
																			longitude_destino: null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />

													{item.destino == 'unidade' &&
													<Select
														options={this.props.listaUnidade}
														cols='12 3 3 3'
														label='Unidade'
														placeholder='Selecione a unidade'
														readOnly={readOnly}
														value={item.id_unidade_destino}
														onChange={(data) => {

															const unidade = this.props.listaUnidade.filter(item => item.id == data)[0];
															
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_unidade_destino: data,
																			latitude_destino: unidade ? unidade.latitude : null,
																			longitude_destino: unidade ? unidade.longitude : null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}
													
													{item.destino == 'cliente' &&
													<Select
														options={this.props.listaCliente}
														cols='12 3 3 3'
														label='Cliente'
														placeholder='Selecione o cliente'
														readOnly={readOnly}
														value={item.id_cliente_destino}
														onChange={(data) => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_cliente_destino: data,
																			id_endereco_destino: null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}

													{item.destino == 'cliente' &&
													<Select
														options={this.props.listaEndereco.filter(endereco => endereco.id_cliente == item.id_cliente_destino)}
														cols='12 3 3 3'
														label='Endereço'
														placeholder='Selecione o endereço'
														readOnly={readOnly}
														value={item.id_endereco_destino}
														onChange={(data) => {

															const endereco = this.props.listaEndereco.filter(item => item.id == data)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_endereco_destino: data,
																			latitude_destino: endereco ? endereco.latitude : null,
																			longitude_destino: endereco ? endereco.longitude : null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}

													{item.destino == 'distribuidora' &&
													<Select
														options={this.props.listaDistribuidora}
														cols='12 3 3 3'
														label='Distribuidora'
														placeholder='Selecione a distribuidora'
														readOnly={readOnly}
														value={item.id_distribuidora_destino}
														onChange={(data) => {

															const distribuidora = this.props.listaDistribuidora.filter(item => item.id == data)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_distribuidora_destino: data,
																			latitude_destino: distribuidora ? distribuidora.latitude : null,
																			longitude_destino: distribuidora ? distribuidora.longitude : null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}

													{item.destino == 'local' &&
													<Select
														options={this.props.listaLocal}
														cols='12 3 3 3'
														label='Outro Local'
														placeholder='Selecione o local'
														readOnly={readOnly}
														value={item.id_local_destino}
														onChange={(data) => {

															const local = this.props.listaLocal.filter(item => item.id == data)[0];

															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_local_destino: data,
																			latitude_destino: local ? local.latitude : null,
																			longitude_destino: local ? local.longitude : null
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />}
													
													<LabelAndInput
														cols='12 1 1 1'
														minWidth={300}
														label='Localizacão'
														readOnly={'readOnly'}
														placeholder=''
														value={item.latitude_destino && item.longitude_destino ? `${item.latitude_destino}, ${item.longitude_destino}` : ''}
														onChange={(data) => {
														}} />
												</Row>
												<Row>
													<Select
														options={this.props.listaFreteDeslocamento}
														cols='12 3 3 3'
														label='Deslocamento'
														placeholder='Selecione o deslocamento'
														readOnly={readOnly}
														value={item.id_deslocamento}
														onChange={(data) => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_deslocamento: data
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />
													
													<LabelAndInputNumber
														label='Quantidade' 
														placeholder='Informe o quantidade'
														cols='12 1 1 1'
														minWidth={200}
														casas={2}
														readOnly={readOnly}
														value={item.quantidade}
														onChange={data => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			quantidade: data.target.value
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />
													
													{/*<Select
														options={this.props.listaUnidadeMedida}
														cols='12 3 3 3'
														label='Unidade de Medida'
														placeholder='Selecione a unidade de medida'
														value={item.id_unidade_medida}
														onChange={(data) => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			id_unidade_medida: data
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />*/}
														
													<LabelAndInputNumber
														label='Custo Km Rodado' 
														placeholder='Informe o custo'
														cols='12 1 1 1'
														minWidth={200}
														casas={2}
														readOnly={readOnly}
														value={item.custo_km_rodado}
														onChange={data => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			custo_km_rodado: data.target.value
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />
													
													<LabelAndInputNumber
														label='Km Total' 
														placeholder='Informe a km total'
														cols='12 1 1 1'
														minWidth={200}
														casas={0}
														readOnly={readOnly}
														value={item.km_total}
														onChange={data => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			km_total: data.target.value
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />

													<LabelAndInputNumber
														label='Custo Total' 
														placeholder='Informe a km total'
														cols='12 1 1 1'
														minWidth={200}
														casas={2}
														readOnly={'readOnly'}
														value={FormatUtils.formatarValorTela((parseFloat(FormatUtils.formatarValorBanco(item.custo_km_rodado, 2)) * parseFloat(FormatUtils.formatarValorBanco(item.km_total, 0))).toFixed(2), 2)}
														onChange={data => {
														}} />
												</Row>

												<Row>
													<LabelAndInput
														label='Chegada na Origem' 
														cols='12 1 1 1'
														minWidth={180}
														readOnly={'readOnly'}
														value={DateFormat.formatarDataHoraSqlParaTela(item.datahora_chegada_origem)}
														onChange={data => {
														}} />													

													<div
														style={{
															position: 'relative',
															marginTop: 0,
															marginLeft: 0,
															width: 38,
															height: 38
														}} >
														<input
															ref={ref => this[`dtChegadaOrigem${i}`] = ref}
															type="datetime-local"
															style={{
																position: 'absolute',
																opacity: 0,
																pointerEvents: 'none',
																width: 0,
																height: 0
															}}
															onChange={e => {
																this.props.initForm({
																	...this.props.formularioValues,
																	itens: this.props.formularioValues.itens.map(itemAux => {
																		if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																			return {
																				...itemAux,
																				datahora_chegada_origem: e.target.value ? DateFormat.formatarDataHoraPickerParaBanco(e.target.value) : null
																			}
																		} else {
																			return itemAux;
																		}
																	})
																}, true);
															}}
														/>

														<button
															type="button"
															className="btn btn-outline-primary"
															style={{
																marginLeft: -6,
																height: 38,
																width: 38,
																borderRadius: 8,
																marginTop: 29
															}}
															title="Alterar data e hora"
															onClick={() => {
																const input = this[`dtChegadaOrigem${i}`];

																if (input.showPicker) {
																	input.showPicker();
																} else {
																	input.click();
																}
															}}
														>
															<i className="fas fa-calendar-alt"></i>
														</button>
													</div>

													<LabelAndInput
														label='Saída da Origem' 
														cols='12 1 1 1'
														minWidth={180}
														readOnly={'readOnly'}
														value={DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicial)}
														onChange={data => {
														}} />

													<div
														style={{
															position: 'relative',
															marginTop: 0,
															marginLeft: 0,
															width: 38,
															height: 38
														}} >
														<input
															ref={ref => this[`dtInicial${i}`] = ref}
															type="datetime-local"
															style={{
																position: 'absolute',
																opacity: 0,
																pointerEvents: 'none',
																width: 0,
																height: 0
															}}
															onChange={e => {
																this.props.initForm({
																	...this.props.formularioValues,
																	itens: this.props.formularioValues.itens.map(itemAux => {
																		if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																			return {
																				...itemAux,
																				datahora_inicial: e.target.value ? DateFormat.formatarDataHoraPickerParaBanco(e.target.value) : null
																			}
																		} else {
																			return itemAux;
																		}
																	})
																}, true);
															}}
														/>

														<button
															type="button"
															className="btn btn-outline-primary"
															style={{
																marginLeft: -6,
																height: 38,
																width: 38,
																borderRadius: 8,
																marginTop: 29
															}}
															title="Alterar data e hora"
															onClick={() => {
																const input = this[`dtInicial${i}`];

																if (input.showPicker) {
																	input.showPicker();
																} else {
																	input.click();
																}
															}}
														>
															<i className="fas fa-calendar-alt"></i>
														</button>
													</div>
													<LabelAndInputNumber
														label='Km Inicial' 
														placeholder='Informe'
														cols='12 1 1 1'
														minWidth={200}
														casas={0}
														readOnly={readOnly}
														value={item.km_inicial}
														onChange={data => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			km_inicial: parseInt(FormatUtils.formatarValorBanco(data.target.value, 0)),
																			km_percorrida: parseInt(item.km_final || 0) > 0 ? parseInt(item.km_final) - parseInt(FormatUtils.formatarValorBanco(data.target.value, 0) || 0) : item.km_percorrida
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />
													
													<LabelAndInput
														label='Chegada no Destino' 
														cols='12 1 1 1'
														minWidth={180}
														readOnly={'readOnly'}
														value={DateFormat.formatarDataHoraSqlParaTela(item.datahora_final)}
														onChange={data => {
														}} />

													<div
														style={{
															position: 'relative',
															marginTop: 0,
															marginLeft: 0,
															width: 38,
															height: 38
														}} >
														<input
															ref={ref => this[`dtFinal${i}`] = ref}
															type="datetime-local"
															style={{
																position: 'absolute',
																opacity: 0,
																pointerEvents: 'none',
																width: 0,
																height: 0
															}}
															onChange={e => {
																this.props.initForm({
																	...this.props.formularioValues,
																	itens: this.props.formularioValues.itens.map(itemAux => {
																		if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																			return {
																				...itemAux,
																				datahora_final: e.target.value ? DateFormat.formatarDataHoraPickerParaBanco(e.target.value) : null
																			}
																		} else {
																			return itemAux;
																		}
																	})
																}, true);
															}}
														/>

														<button
															type="button"
															className="btn btn-outline-primary"
															style={{
																marginLeft: -6,
																height: 38,
																width: 38,
																borderRadius: 8,
																marginTop: 29
															}}
															title="Alterar data e hora"
															onClick={() => {
																const input = this[`dtFinal${i}`];

																if (input.showPicker) {
																	input.showPicker();
																} else {
																	input.click();
																}
															}}
														>
															<i className="fas fa-calendar-alt"></i>
														</button>
													</div>
													
													<LabelAndInputNumber
														label='Km Final' 
														placeholder='Informe'
														cols='12 1 1 1'
														minWidth={200}
														casas={0}
														readOnly={readOnly}
														value={item.km_final}
														onChange={data => {
															this.props.initForm({
																...this.props.formularioValues,
																itens: this.props.formularioValues.itens.map(itemAux => {
																	if (itemAux.id ? item.id == itemAux.id : item.idAux == itemAux.idAux) {
																		return {
																			...itemAux,
																			km_final: parseInt(FormatUtils.formatarValorBanco(data.target.value, 0)),
																			km_percorrida: parseInt(FormatUtils.formatarValorBanco(data.target.value, 0) || 0) > 0 ? parseInt(FormatUtils.formatarValorBanco(data.target.value, 0)) - parseInt(item.km_inicial || 0) : item.km_percorrida
																		}
																	} else {
																		return itemAux;
																	}
																})
															}, true);
														}} />
													
													<LabelAndInputNumber
														label='Km Percorrida' 
														placeholder='Informe'
														cols='12 1 1 1'
														minWidth={200}
														casas={0}
														readOnly={'readOnly'}
														value={item.km_percorrida}
														onChange={data => {
															
														}} />
												</Row>
											</ContentCardBody>
										</ContentCard>
									</Grid>
								</Row>
							)
						})}

						<br />

						<Row>
							<Grid cols='12 4 4 2'>
								<Button
									text='Adicionar Rota'
									type={'success'}
									icon={'fa fa-plus'}
									event={() => {
										let lista = (this.props.formularioValues.itens || []).map(item => item);
										lista.push({ idAux: new Date().getTime(), id_unidade_medida: 1, ativo: true });
										this.props.initForm({
											...this.props.formularioValues,
											itens: lista
										});
									}} />
									
							</Grid>
							
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

FreteForm = reduxForm({form: 'freteForm', destroyOnUnmount: false})(FreteForm);
const mapStateToProps = state => ({
	sessao: state.auth.frete,
	formularioValues: getFormValues('freteForm')(state),
	registro: state.frete.registro,
	listaMotorista: state.frete.listaMotorista,
    listaVeiculo: state.frete.listaVeiculo,
    listaUnidade: state.unidade.listaSelect,
	listaDistribuidora: state.distribuidora.listaSelect,
	listaLocal: state.local.listaSelect,
    listaCliente: state.frete.listaCliente,
    listaEndereco: state.frete.listaEndereco,
    listaFreteDeslocamento: state.frete.listaFreteDeslocamento,
    listaUnidadeMedida: state.frete.listaUnidadeMedida
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(FreteForm);
